import React, { useState, useRef, useEffect } from "react";
import downloadIcon from "../../assets/images/pdf_viewer/download_icon_for_pdf.svg";
import downloadIconDark from "../../assets/images/pdf_viewer/download_icon_for_pdf_dark_mode.svg";
import printIcon from "../../assets/images/pdf_viewer/print_icon_pdf.svg";
import printIconDark from "../../assets/images/pdf_viewer/print_icon_pdf_dark_mode.svg";
import slideshowIcon from "../../assets/images/pdf_viewer/slideshow.svg";
import slideshowIconDark from "../../assets/images/pdf_viewer/slideshow_dark_mode.svg";
import commentsIcon from "../../assets/images/pdf_viewer/comments.svg";
import commentsIconDark from "../../assets/images/pdf_viewer/comments_dark_mode.svg";
import fullscreenIcon from "../../assets/images/pdf_viewer/full_screen.svg";
import fullscreenIconDark from "../../assets/images/pdf_viewer/full_screen_dark_mode.svg";

const Toolbar = ({
  currentPage,
  totalPages,
  scale,
  onZoomIn,
  onZoomOut,
  onResetZoom,
  onFitWidth,
  onRotateLeft,
  onRotateRight,
  onToggleSidebar,
  onDownload,
  onPrint,
  onFullscreen,
  onSlides,
  onComment,
  isCommentMode = false,
  onEdit,
  isEditMode = false,
  isPreparingEditMode = false,
  theme = "light",
  disableZoomIn = false,
  disableZoomOut = false,
  onClose,
}) => {
  return (
    <div className="pdf-toolbar">
      <div className="pdf-toolbar-section">
        <button className="pdf-toolbar-button mobile-hamburger hide-on-mobile" onClick={onToggleSidebar} title="Toggle sidebar">
          <span>☰</span>
        </button>
        <span className="pdf-page-info hide-on-mobile">
          Page {currentPage} of {totalPages}
        </span>
      </div>
      <div className="pdf-toolbar-section">
        <button className="pdf-toolbar-button" onClick={onZoomOut} title={isEditMode ? "Zoom out disabled in draw mode" : (disableZoomOut ? "Minimum zoom reached" : "Zoom out")} disabled={isEditMode || disableZoomOut}>
          <span>-</span>
        </button>
        <span className="pdf-zoom-label hide-on-mobile">{Math.round(scale * 100)}%</span>
        <button className="pdf-toolbar-button" onClick={onZoomIn} title={isEditMode ? "Zoom in disabled in draw mode" : (disableZoomIn ? "Fit width reached" : "Zoom in")} disabled={isEditMode || disableZoomIn}>
          <span>+</span>
        </button>
        <button className="pdf-toolbar-button hide-on-mobile" onClick={onResetZoom} title={isEditMode ? "Reset zoom disabled in draw mode" : "Reset zoom"} disabled={isEditMode}>
          100%
        </button>
        <button className="pdf-toolbar-button hide-on-mobile" onClick={onFitWidth} title={isEditMode ? "Fit width disabled in draw mode" : "Fit width"} disabled={isEditMode}>
          <span className="hide-on-mobile">Fit width</span>
          <span className="show-on-mobile">⤢</span>
        </button>
      </div>
      <div className="pdf-toolbar-section">
        <button className="pdf-toolbar-button" onClick={onRotateLeft} title={isEditMode ? "Rotate left disabled in draw mode" : "Rotate left"} disabled={isEditMode}>
          <span>⟲</span>
        </button>
        <button className="pdf-toolbar-button" onClick={onRotateRight} title={isEditMode ? "Rotate right disabled in draw mode" : "Rotate right"} disabled={isEditMode}>
          <span>⟳</span>
        </button>
      </div>
      <div className="pdf-toolbar-section">
        <button
          className="pdf-toolbar-button hide-on-mobile"
          onClick={onDownload}
          title={isEditMode ? "Download disabled in draw mode" : "Download"}
          disabled={isEditMode}
        >
          <img
            src={theme === "dark" ? downloadIconDark : downloadIcon}
            alt="Download"
            style={{ width: "16px", height: "16px", opacity: isEditMode ? 0.5 : 1 }}
          />
        </button>
        <button
          className="pdf-toolbar-button hide-on-mobile"
          onClick={onPrint}
          title={isEditMode ? "Print disabled in draw mode" : "Print"}
          disabled={isEditMode}
        >
          <img
            src={theme === "dark" ? printIconDark : printIcon}
            alt="Print"
            style={{ width: "16px", height: "16px", opacity: isEditMode ? 0.5 : 1 }}
          />
        </button>
        <button
          className="pdf-toolbar-button hide-on-mobile"
          onClick={onSlides}
          title={isEditMode ? "Slides disabled in draw mode" : "Slides"}
          disabled={isEditMode}
        >
          <img
            src={theme === "dark" ? slideshowIconDark : slideshowIcon}
            alt="Slides"
            style={{ width: "16px", height: "16px", opacity: isEditMode ? 0.5 : 1 }}
          />
        </button>
        <button
          className={`pdf-toolbar-button hide-on-mobile ${isCommentMode ? "pdf-toolbar-button-active" : ""}`}
          onClick={onComment}
          title={isEditMode ? "Comments disabled in draw mode" : "comments"}
          disabled={isEditMode}
        >
          <img
            src={theme === "dark" || isCommentMode ? commentsIconDark : commentsIcon}
            alt="Comment"
            style={{
              width: "16px",
              height: "16px",
              opacity: isEditMode ? 0.5 : 1,
              filter: isCommentMode ? "brightness(0) invert(1)" : "none"
            }}
          />
        </button>
        <button
          className={`pdf-toolbar-button hide-on-mobile ${isEditMode ? "pdf-toolbar-button-active" : ""}`}
          onClick={onEdit}
          disabled={isPreparingEditMode}
          title={isPreparingEditMode ? "Preparing edit mode..." : "Edit PDF"}
        >
          <span>{isPreparingEditMode ? "⏳" : "✏️"}</span>
        </button>
        <button
          className="pdf-toolbar-button"
          onClick={onFullscreen}
          title={isEditMode ? "Fullscreen disabled in draw mode" : "Fullscreen"}
          disabled={isEditMode}
        >
          <img
            src={theme === "dark" ? fullscreenIconDark : fullscreenIcon}
            alt="Fullscreen"
            style={{ width: "16px", height: "16px", opacity: isEditMode ? 0.5 : 1 }}
          />
        </button>

        <button
          className="pdf-toolbar-button show-on-mobile"
          onClick={onDownload}
          title={isEditMode ? "Download disabled in draw mode" : "Download"}
          disabled={isEditMode}
        >
          <img
            src={theme === "dark" ? downloadIconDark : downloadIcon}
            alt="Download"
            style={{ width: "16px", height: "16px", opacity: isEditMode ? 0.5 : 1 }}
          />
        </button>

        <button
          className="pdf-toolbar-button show-on-mobile"
          onClick={onClose}
          title="Close PDF"
        >
          <span>✕</span>
        </button>
      </div>
    </div>
  );
};

export default Toolbar;

